import axios from 'axios';
// import store from '../store';

function errorHandler(error, reject) {
    console.log(error);
    if (error.response && error.response.data) {
        reject(error.response.data);
    } else {
        reject(error);
    }
}
const baseurl = 'releasedoc';
export default {
    save(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(baseurl, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    list(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'pinjamankey',
                'sourceproject'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    detail(key) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/detail/${key}`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    printPDF(releaseKey) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/printPDF/${releaseKey}`);
                const link = `${process.env.VUE_APP_BASE_API}/printpreview/pdf/${data.id}`
                resolve(link);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    approval(formData) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/send2wf`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                });
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    approvalUndo(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const resp = await axios.put(`${baseurl}/send2wfCancel/${obj.pelunasankey}`);
                resolve(resp);
            } catch (error) {
                errorHandler(error, reject);
            }
        });
    },
    getworkflow() {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.get(`${baseurl}/getworkflow`);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    listreadytosettlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/ready-to-settlement${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
    settlement(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const { data } = await axios.post(`${baseurl}/settlement`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    settled(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/settled${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    readyreleasedocument(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const keys = ['page', 'limit', 'sortBy', 'sortDir', 'CustName','CustCode', 'collectability', 'collector_id', 'model_pinjaman', 
                'tglsurat1', 'tglsurat2','tgl1', 'tgl2','rrd_dt1', 'rrd_dt2','nomor','status_memo', 
                'agreement', 'contract_status', 'wo_status','nosurat','pinjamankey','posting'];
                let str = '';
                for (const key in obj) {
                    if (keys.indexOf(key) >= 0 && obj[key]) {
                        str += str ? '&' : '?';
                        str += key + '=' + encodeURIComponent(obj[key]);
                    }
                }
                const url = `/${baseurl}/ready-release-document${str}`;
                const { data } = await axios.get(url);
                const { meta, list } = data;
                obj.total = meta.total;
                resolve(list);
            } catch (error) {
                errorHandler(error, reject)
            }
        });
    },
    exportxlsRRD(obj = {}) {
        const keys = ['page', 'limit', 'sortBy', 'sortDir', 'uraian', 'DimCol', 'DimVal', 'tgl1', 'tgl2', 'status', 'nomor', 'customer', 'kodebank', 'namabank', 'reference', 'tgldue1', 'tgldue2', 'unearned', 'collector_id'];

        let str = '';
        for (const key in obj) {
            if (keys.indexOf(key) >= 0 && obj[key]) {
                str += str ? '&' : '?';
                str += key + '=' + encodeURIComponent(obj[key]);
            }
        }

        axios({
            url: `/${baseurl}/exportxls-rrd${str}`,
            method: 'GET',
            responseType: 'blob', // important
        }).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'RRD.xlsx');
            document.body.appendChild(link);
            link.click();
            // window.location.assign(url);
        });
    },
    
    saveRequestRRD(obj) {
        return new Promise(async (resolve, reject) => {
            try {
                const {data} = await axios.post(`${baseurl}/saveRequestRRD`, obj);
                resolve(data);
            } catch (error) {
                errorHandler(error, reject)
            }
        })
    },
}